import server from '../../plugins/server';
import $f from '../../plugins/functions';
import countries from '../../assets/data/countries.json';
export default {
  namespaced: true,
  state() {
    return {
      warhouseSelected: localStorage.getItem('countryW') || 'CI',
      changeW: false,
      warhouses: [],
      options: countries,
      warehouses: [],
      warehousesUser: [],
      warehousesSeller: [],
    };
  },

  mutations: {
    changeWrahouse: function(state, payload) {
      state.warhouseSelected = payload.warhouse;
      state.changeW = true;
      
    },
  },
  actions: {
    async searchUser({ commit }, payload) {
      if (payload.type != 'zone') {
        const filter = {
          type: payload.type[0].toUpperCase() + payload.type.slice(1),
          limit: 10,
          countries: payload.warhouse,
          name: payload.search,
        };
        
        const res = await server.find('users', filter);
        
        if (res.content) return res.content.results;
        else return [];
      } else {
        const filter = {
          limit: 10,
          country: payload.warhouse,
          name: payload.search,
        };
        
        const res = await server.find('zones', filter);
        
        if (res.content.results) return res.content.results;
        else return [];
      }
    },
    async searchPricesOrders({ commit }, payload) {
      
      let filter = {
        seller: payload.seller,
        product: payload.product,
        country: payload.country,
        distinctPrices: true,
      };
      if (payload.status) filter.status = payload.status;
      
      const res = await server.find(payload.table, filter);
      
      if (res.content && res.content.results) return res.content.results;
      else return [];
    },
    async searchStoresOrders({ commit }, payload) {
      
      let filter = {
        seller: payload.seller,
        country: payload.country,
        distinctStores: true,
      };
      if (payload.status) filter.status = payload.status;
      if (payload.product) filter.product = payload.product;
      
      const res = await server.find(payload.table, filter);
      
      if (res.content && res.content.results) return res.content.results;
      else return [];
    },
    async searchApiStatus({ commit }, payload) {
      
      let filter = {
        country: payload.country,
        distinctApiStatus: true,
      };
      if (payload.status) filter.status = payload.status;
      
      const res = await server.find(payload.table, filter);
      
      if (res.content && res.content.results) return res.content.results;
      else return [];
    },
    async searchProducts({ commit }, payload) {
      const filter = {
        limit: 10,
        seller: payload.seller,
        'details.warehouse': payload.warhouse,
        name: payload.search,
      };
      
      const res = await server.find('products', filter);
      
      if (res.content && res.content.results) return res.content.results;
      else return [];
    },
    changeWrahouse(context, payload) {
      context.commit('changeWrahouse', payload);
    },
    async getwharhouseId({ getters }) {
      const resW = await server.get('warehouses', {
        country: await getters.warhouseSelected,
        is_primary: true,
      });
      if (resW.content) return resW.content;
    },
    async getCurrency({ getters }) {
      const resW = await server.get('warehouses', {
        country: await getters.warhouseSelected,
        is_primary: true,
      });
      if (resW.content) return resW.content.currency;
    },
    async getwharhouseSeller() {
      const resW = await server.get('products', { allWarhouseSeller: true });
      return resW.content;
    },
    async getWarehouses({ commit, state }) {
      const filter = { limit: 1000 };
      state.warehouses = [];
      state.warehousesUser = [];
      const resUser = await server.me('users');
      if (resUser.content) {
        if (resUser.content.countries) {
          state.warehousesUser = resUser.content.countries;
          if (resUser.content.type == 'Seller') {
            const resWExpe = await server.get('expeditions', {
              allWarhouseSeller: true,
            });
            if (resWExpe.content.length > 0) {
              for (let i in resWExpe.content) {
                if (state.warehousesUser.indexOf(resWExpe.content[i]) === -1)
                  state.warehousesUser.push(resWExpe.content[i]);
              }
            }
          }
          for (let i in state.warehousesUser) {
            state.warehousesUser[i] = {
              name: $f.getCountryNameByCode(
                state.options,
                state.warehousesUser[i],
              ),
              code: state.warehousesUser[i],
            };
          }
        }
      }

      if (state.warehousesUser.length > 0) {
        state.warehouses = state.warehousesUser;
      } else {
        const res = await server.search('warehouses', filter);
        if (res.content.results) {
          let data = res.content.results;
          for (let i in data) {
            state.warehouses.push({
              name: $f.getCountryNameByCode(state.options, data[i].country),
              code: data[i].country,
            });
          }
        } else state.warehouses = [];
      }
      return state.warehouses;
    },
  },
  getters: {
    async warhouseSelected(state) {
      if (!state.changeW) {
        //const resW = await server.get("products", { allWarhouseSeller: true});
        const resUser = await server.me('users');
        //check if user has countries warhouse
        if (resUser.content.countries && resUser.content.countries.length > 0) {
          return (
            localStorage.getItem('countryW') || resUser.content.countries[0]
          );
        }
      }
      return state.warhouseSelected;
    },
    async warehouses(state) {
      const filter = { limit: 1000 };
      state.warehousesUser = [];
      state.warehouses = [];
      const resUser = await server.me('users');
      if (resUser.content) {
        if (resUser.content.countries) {
          state.warehousesUser = resUser.content.countries;
          if (resUser.content.type == 'Seller') {
            const resWExpe = await server.get('expeditions', {
              allWarhouseSeller: true,
            });
            if (resWExpe.content.length > 0) {
              for (let i in resWExpe.content) {
                if (state.warehousesUser.indexOf(resWExpe.content[i]) === -1)
                  state.warehousesUser.push(resWExpe.content[i]);
              }
            }
          }
          for (let i in state.warehousesUser) {
            state.warehousesUser[i] = {
              name: $f.getCountryNameByCode(
                state.options,
                state.warehousesUser[i],
              ),
              code: state.warehousesUser[i],
            };
          }
        }
      }

      if (state.warehousesUser.length > 0) {
        state.warehouses = state.warehousesUser;
      } else {
        const res = await server.search('warehouses', filter);
        if (res.content.results) {
          let data = res.content.results;
          for (let i in data) {
            state.warehouses.push({
              name: $f.getCountryNameByCode(state.options, data[i].country),
              code: data[i].country,
            });
          }
        } else state.warehouses = [];
      }
      
      return state.warehouses;
    },
  },
};
